import React from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton, SecondaryButton } from "@ucl/library";
import "./NotFound.scss";

interface NotFoundProps {
  homePath?: string;
}

export const NotFound: React.FC<NotFoundProps> = ({ homePath = "/" }) => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate(homePath);
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <section className="not-found">
      <div className="not-found__content">
        <div className="not-found__header">
          <h1 className="not-found__title">Page Not Found</h1>
          <div className="not-found__icon">404</div>
        </div>
        <p className="not-found__description">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="not-found__actions">
          <PrimaryButton text="Go to Home" onClick={goToHome} />
          <SecondaryButton text="Go Back" onClick={goBack} minimal />
        </div>
      </div>
    </section>
  );
};
